<template>
    <div class="cause-component">
        <h1>Post Details</h1>
    </div>
</template>

<script>

export default {
    name: "Post_details",

    components: {},

    props: ["postDetails"],

    data: function () {
        return {
            postSingle: {},
        };
    },

    mounted() {
        switch (this.postType) {
            case "cause":
                this.noMorePosts = "No more organizations";
                this.urls = {
                    tags: "npos/listtags",
                    posts: "npos/list"
                };
                break;
            case "partner":
                this.noMorePosts = "No more locations";
                this.urls = {
                    tags: "retailer/listtags",
                    posts: "retailer/list"
                };
                break;
            default:
                this.noMorePosts = "No more organizations";
                this.urls = {
                    tags: "",
                    posts: ""
                };
        }
        // this.getTags();
        // this.getPosts();
    },

    methods: {}
};
</script>
